const publicVapidKey =
  "BPHqJblia3xO46dfBCC2Tvg5jBYlWrA27OEaWU2IUO7ihmvTwg8GDQ_k-ubJkrBJiCtzxucSMjhb2Ov2-OhivE8";

export const isSupported = () => {
  const notificationsAllowed = "Notification" in window;
  const serviceWorkerAllowed = "serviceWorker" in navigator;
  const pushAllowed = "PushManager" in window;
  return notificationsAllowed && serviceWorkerAllowed && pushAllowed;
};

export const checkPermission = async () => {
  if (!isSupported()) {
    return false;
  }

  if (Notification.permission === "granted") {
    return true;
  }

  const permission = await Notification.requestPermission();
  if (permission === "granted") {
    return true;
  }

  return false;
};

// https://gist.github.com/Klerith/80abd742d726dd587f4bd5d6a0ab26b6
const urlBase64ToUint8Array = (base64String: string) => {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  // eslint-disable-next-line
  const base64 = (base64String + padding)
    // eslint-disable-next-line
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

export const registerWorker = async () => {
  if (!isSupported()) {
    return null;
  }

  const registration = await navigator.serviceWorker.register(`/sw.js`, {
    scope: "/",
  });

  return registration;
};

export const getPushSubscription = async () => {
  if (!isSupported()) {
    return null;
  }

  if (Notification.permission !== "granted") {
    return null;
  }

  const registration = await registerWorker();

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    try {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
      });
    } catch (err) {
      console.error("Error subscribing with push manager", err);
    }
  }
  return subscription;
};
